import React from 'react';
import PropTypes from 'prop-types';

import {
    DescriptionWrapper
} from './Summary.style';

const Description = ({
    description
}) => {
    return (
        <DescriptionWrapper>{description}</DescriptionWrapper>
    );
};

Description.propTypes = {
  description: PropTypes.string
};

export default Description;
